import { type ReactNode } from 'react'

interface CardProps {
  children: ReactNode
  className?: string
  footer?: ReactNode
}

export function Card({ children, className = '', footer }: CardProps) {
  return (
    <div className={`rounded-lg border border-border bg-canvas ${className}`}>
      {children}
      {footer && <div className="border-t border-border px-4 py-3">{footer}</div>}
    </div>
  )
}
